import { useState } from "react";
// import { FaHome, FaChartBar, FaCog, FaSignOutAlt } from "react-icons/fa";
// import adminimg from "../../utils/images/admin_img.png";
// import leftlogo from "../../utils/images/left_logo.png";
import { FiUser, FiMapPin, FiClipboard, FiFolder, FiDownload, } from "react-icons/fi";
import { MdPrint } from "react-icons/md";
import { FiX } from 'react-icons/fi';
// import { MdPrint } from "react-icons/md";
import { ChevronLeft } from "lucide-react";
// import { FaPen } from "react-icons/fa";
// import { FiSearch } from "react-icons/fi";
import reset from "../../utils/images/reset_icon.svg";
import Sidebar from "../../component/Sidebar";
import { useDispatch } from "react-redux";
import { clientAction } from "../../_actions";
import { useNavigate } from "react-router-dom";
// import { FaChevronUp, FaChevronDown } from "react-icons/fa";

function ClientAdress() {
    const [isOpen, setIsOpen] = useState(false);
    const toggleSidebar = () => setIsOpen(!isOpen);
    const [activeTab, setActiveTab] = useState("Calendar & Tasks");
    const [tab, setTab] = useState("Street");
    const [activeButton, setActiveButton] = useState("save");
    const [ActiveAction, setActiveAction] = useState("Adress");
    // const [search, setSearch] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errors, setErrors] = useState("");
    const [clientData, setClientData] = useState({
        unit: "",
        number: "",
        street_name: "",
        city: "",
        postcode: "",
        country: "",
        building_name: "",
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!validate()) return;

        dispatch(clientAction.createClientAddress(clientData));
        setClientData({
            unit: "",
            number: "",
            street_name: "",
            city: "",
            postcode: "",
            country: "",
            building_name: "",
        });
    };

    const handleReset = () => {
        setClientData({
            unit: "",
            number: "",
            street_name: "",
            city: "",
            postcode: "",
            country: "",
            building_name: "",
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setClientData((preData) => ({
            ...preData,
            [name]: value,
        }));

        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: "",
            }));
        }
    };

    const validate = () => {
        const newError = {};

        if (!clientData.unit) {
            newError.unit = "Unit/Level is requird";
        }
        if (!clientData.number) {
            newError.number = "Number is requird";
        }
        if (!clientData.street_name) {
            newError.street_name = "Street Name is requird";
        }
        if (!clientData.city) {
            newError.city = "City is requird";
        }
        if (!clientData.postcode) {
            newError.postcode = "Postcode is requird";
        }
        if (!clientData.country) {
            newError.country = "Country is requird";
        }
        if (!clientData.building_name) {
            newError.building_name = "Building name is requird";
        }
        setErrors(newError);
        return Object.keys(newError).length === 0;
    };
    // console.log(setClientData);

    // const handlePrint = () => {
    //     window.print();FiSearch 
    //   };

    return (
        <div className="main-wrapper-dashboard">
            <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
            <div className="right-dashboard">
                <div
                    className={`dashboard-screen matter-details client-address ${isOpen ? "main-content-width" : "main-content-small-width"
                        }`}
                >
                    <div className="dashboard-header-bottom">
                        <div className="dashboard-content shadow">
                            <div className="left-icon">
                                <span
                                    className={`font-bold cursor-pointer ${activeTab == "Calendar" ? "text-white underline" : ""
                                        }`}
                                    onClick={() => setActiveTab("Details & Correspondence")}
                                >
                                    Matter Type
                                    <ChevronLeft className="w-4 h-4 ml-1" />
                                </span>
                                <span
                                    className={`font-bold cursor-pointer ${activeTab === "Calendar" ? "text-white underline" : ""
                                        }`}
                                    onClick={() => setActiveTab("Calendar & Tasks")}
                                >
                                    Matter Details
                                    <ChevronLeft className="w-4 h-4 ml-1" />
                                </span>
                                <span
                                    className={`font-bold cursor-pointer ${activeTab === "Calendar" ? "text-white underline" : ""
                                        }`}
                                    onClick={() => setActiveTab("Financial Summary")}
                                >
                                    Client Details
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="dashboard-details-content">
                        <div className="third-section">
                            <div className="action-sidebar overflow-y-auto scrollable-container max-h-96 scrollbar-thin scrollbar-thumb-cyan-700 scrollbar-track-gray-100">
                                <h2 className="action-title">Card Type</h2>
                                <div className="people-container">
                                    <select className="dropdown">
                                        <option>People</option>
                                    </select>

                                    <div className="title-row">
                                        <h3>People on Card (1)</h3>
                                        <button className="add-btn">+</button>
                                    </div>

                                    <div className="person-card">
                                        <div className="avatar">LR</div>
                                        <div className="name">Lisa Robertson</div>
                                    </div>
                                </div>
                                <div>
                                    <div className={`action-item ${ActiveAction === "General" ? "active" : ""
                                        }`}
                                        onClick={() => setActiveAction("General")}>
                                        <div className="action-label">
                                            <FiUser className="icon" size={18} />
                                            <span className="action-text">General Details</span>
                                        </div>
                                    </div>
                                    <div className={`action-item ${ActiveAction === "Adress" ? "active" : ""
                                        }`}
                                        onClick={() => setActiveAction("Adress")}>
                                        <div className="action-label">
                                            <FiMapPin className="icon" />
                                            <span className="action-text">Adress</span>
                                        </div>
                                    </div>
                                    <div className={`action-item ${ActiveAction === "Notes" ? "active" : ""
                                        }`}
                                        onClick={() => setActiveAction("Notes")}>
                                        <div className="action-label">
                                            <FiClipboard className="icon" />
                                            <span className="action-text">Notes & Other</span>
                                        </div>
                                    </div>
                                    <div className={`action-item ${ActiveAction === "Matters" ? "active" : ""
                                        }`}
                                        onClick={() => setActiveAction("Matters")}>
                                        <div className="action-label">
                                            <FiFolder className="icon" />
                                            <span className="action-text">Matters</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="client-address-details">
                            <div className="client-address">
                                <h2 className="address-title">Address</h2>
                            </div>
                            <div className="address-form">
                                <div className="tab-buttons">
                                    {["Street", "P.O. Box", "D.X"].map((label) => (
                                        <button
                                            key={label}
                                            className={tab === label ? "tab active" : "tab"}
                                            onClick={() => setTab(label)}
                                        >
                                            {label}
                                        </button>
                                    ))}
                                </div>
                                {/* <div className="search-bar">
                                    <FiSearch className='search-icon' />
                                    <input
                                        type="text"
                                        placeholder="Search address…"
                                        value={search}
                                        onChange={handleChange}
                                        className="form-control"
                                    />
                                    <a href="#">Manual Entry</a>
                                </div> */}

                                <div className="form-grid">
                                    <div className="form-row">
                                        <div className="form-col">
                                            <input
                                                name="unit"
                                                placeholder="Unit/Level"
                                                className="form-control nth-child-1"
                                                onChange={handleChange}
                                                value={clientData.unit}
                                            />
                                            {errors.unit && (
                                                <p style={{ color: "red" }}>{errors.unit}</p>
                                            )}
                                        </div>
                                        <div className="form-col">
                                            <input
                                                name="number"
                                                placeholder="Number"
                                                className="form-control nth-child-2"
                                                onChange={handleChange}
                                                value={clientData.number}
                                            />
                                            {errors.number && (
                                                <p style={{ color: "red" }}>{errors.number}</p>
                                            )}
                                        </div>
                                        <div className="form-col">
                                            <input
                                                name="street_name"
                                                placeholder="Street Name"
                                                className="form-control"
                                                onChange={handleChange}
                                                value={clientData.street_name}
                                            />
                                            {errors.street_name && (
                                                <p style={{ color: "red" }}>{errors.street_name}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-col">
                                            <input
                                                name="city"
                                                placeholder="Town City"
                                                className="form-control"
                                                onChange={handleChange}
                                                value={clientData.city}
                                            />
                                            {errors.city && (
                                                <p style={{ color: "red" }}>{errors.city}</p>
                                            )}
                                        </div>
                                        <div className="form-col">
                                            <input
                                                name="postcode"
                                                placeholder="Postcode"
                                                className="form-control nth-child-3"
                                                onChange={handleChange}
                                                value={clientData.postcode}
                                            />
                                            {errors.postcode && (
                                                <p style={{ color: "red" }}>{errors.postcode}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-col">
                                            <select
                                                className="form-controls"
                                                name="country"
                                                onChange={handleChange}
                                                value={clientData.country}
                                            >
                                                <option>Select a country</option>
                                                <option>USA</option>
                                                <option>UK</option>
                                                <option>Australia</option>
                                            </select>
                                            {errors.country && (
                                                <p style={{ color: "red" }}>{errors.country}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-col">
                                            <input
                                                name="building_name"
                                                placeholder="Building Name"
                                                className="form-control"
                                                onChange={handleChange}
                                                value={clientData.building_name}
                                            />
                                            {errors.building_name && (
                                                <p style={{ color: "red" }}>{errors.building_name}</p>
                                            )}
                                        </div>
                                        {/* <input
                                            placeholder="County"
                                            className="form-control"
                                            onChange={handleChange}
                                            value={c}
                                        /> */}
                                    </div>
                                </div>
                                <div className="bottom-buttons">
                                    <button className="btn reset" onClick={() => handleReset()}>
                                        <div className="reset-icon" /> Reset
                                    </button>

                                    <div className="action-buttons">
                                        <button className={`btn outline ${activeButton === "Print" ? "active" : ""
                                            }`}
                                            onClick={() => { setActiveButton("Print") }} type="button">
                                            <MdPrint /> Print Statement
                                        </button>

                                        <button className={`btn filled ${activeButton === "save" ? "active" : ""
                                            }`}
                                            onClick={(e) => {
                                                setActiveButton("save");
                                                handleSubmit(e);
                                              }}>
                                       
                                            <FiDownload /> Save
                                        </button>

                                        <button
                                            className={`btn outline ${activeButton === "close" ? "active" : ""
                                                }`}
                                            onClick={() => {
                                                setActiveButton("close");
                                                navigate("/dashboard");
                                            }}
                                        >
                                            <FiX /> Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ClientAdress;
